import "./about.css";
import { HeroSection } from "./HeroSection";
import { Inverti } from "./Inverti";
import { Socios } from "./Socios";
import { Valores } from "./Valores";
import { Ventajas } from "./Ventajas";

export const Content = () => {
  return (
    <>
      <div className="top-section-background">
        <HeroSection />
      </div>
      <Socios />
      <Valores />
      <Ventajas />

      <Inverti />
    </>
  );
};
